import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M7 7h-.833C2.833 7 2 7.833 2 11.167v6.666C2 21.167 2.833 22 6.167 22H14.5c3.333 0 4.167-.833 4.167-4.167V16.5M14.5 17.834h1.667"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-width": ".1",
      d: "M9.453 10.892c.143 0 .259.031.34.102.082.072.12.178.12.308 0 .132-.037.24-.119.314-.081.073-.198.106-.34.106H8.446q.283.295.385.72h.621c.143 0 .259.03.34.102s.12.178.12.308c0 .132-.037.24-.119.314-.081.073-.198.105-.34.105h-.577a1.9 1.9 0 0 1-.54 1.155q-.408.417-1.074.568.436.187.792.72l1.06 1.59c.12.19.145.376.063.549-.084.176-.253.258-.486.258a.67.67 0 0 1-.42-.12l-.001-.002a1 1 0 0 1-.232-.283L6.751 15.77v-.001a1.7 1.7 0 0 0-.352-.41l-.122-.085q-.233-.14-.644-.142h-1.07c-.151 0-.274-.038-.358-.12-.084-.083-.122-.203-.122-.35s.038-.264.123-.345.206-.116.356-.116h1.641q.712-.002 1.083-.242.357-.232.455-.687H4.533c-.14 0-.254-.033-.334-.106-.08-.074-.116-.182-.116-.314 0-.13.036-.236.116-.308s.194-.103.334-.103H7.69a1 1 0 0 0-.461-.521q-.36-.197-.966-.198h-1.73c-.14 0-.254-.033-.334-.107s-.116-.181-.116-.313c0-.13.036-.236.116-.308.08-.071.194-.102.334-.102z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M17 1a6 6 0 1 1 0 12 6 6 0 0 1 0-12",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M14 7h6M17 10V4"
    }, null, -1)
  ]))]))
}
export default { render: render }